import type {} from '../InternalClientWindow.js';
import { initWithMessagePort, sfClientSetupFactory } from '../initSafeframeClient.js';

performance?.mark?.('SafeFrame: Enter sf.ts');
if (!window.SFClient) {
    initWithMessagePort(sfClientSetupFactory);
}
